export interface FirestoreFieldI {
  stringValue?: string;
  integerValue?: string;
  doubleValue?: string | number;
  booleanValue?: boolean;
  timestampValue?: string;
  referenceValue?: string;
  arrayValue?: {
    // eslint-disable-next-line no-use-before-define
    values: FirestoreFieldsI[];
  };
  nullValue?: null;
  mapValue?: {
    // eslint-disable-next-line no-use-before-define
    fields: FirestoreFieldsI;
  };
}

type FirestorePathType = 'databases' | 'collections' | 'doc' | 'docs' | 'subcollection';

export interface PathValidationResultI {
  type: FirestorePathType;
  segments: string[];
  isValid: boolean;
  error?: string;
}

export interface FirestoreFieldsI {
  [key: string]: FirestoreFieldI;
}

export interface FirestoreDocumentI {
  name: string;
  fields: {
    [key: string]: {
      stringValue?: string;
      integerValue?: string;
      booleanValue?: boolean;
      timestampValue?: string;
      referenceValue?: string;
    };
  };
  updateTime: string;
}

export interface FirestoreDocsI {
  documents: FirestoreDocumentI[];
  document: FirestoreDocumentI;
  readTime: string;
}

export interface FirestoreQueryI {
  field: string;
  op: 'EQUAL' | 'LESS_THAN' | 'LESS_THAN_OR_EQUAL' | 'GREATER_THAN' | 'GREATER_THAN_OR_EQUAL' | 'ARRAY_CONTAINS' | 'IN' | 'ARRAY_CONTAINS_ANY' | 'NOT_EQUAL' | 'NOT_IN';
  value: string | number | boolean;
}

export interface FilterI {
  field: {
    fieldPath: string;
  };
  op: 'EQUAL' | 'LESS_THAN' | 'LESS_THAN_OR_EQUAL' | 'GREATER_THAN' | 'GREATER_THAN_OR_EQUAL' | 'ARRAY_CONTAINS' | 'IN' | 'ARRAY_CONTAINS_ANY' | 'NOT_EQUAL' | 'NOT_IN';
  value: {
    stringValue?: string;
    integerValue?: string;
    doubleValue?: string | number;
    booleanValue?: boolean;
    timestampValue?: string;
    referenceValue?: string;
    arrayValue?: {
      values: string[];
    };
  }
  fieldError?: string;
  valueError?: string;
  opError?: string;
}

export interface FieldFilterI {
  fieldFilter: FilterI;
}

export interface CompositeFilterI {
  Op: 'AND' | 'OR';
  filters: FieldFilterI[];
}

export interface OrderByI {
  field: {
    fieldPath: string;
  };
  direction: 'ASCENDING' | 'DESCENDING';
}

export interface WhereFilterI {
  compositeFilter: CompositeFilterI;
}

export interface FirestoreDocI {
  name: string;
  fields: FirestoreFieldsI;
  createTime: string;
  updateTime: string;
}

export interface FirestoreDatabaseI {
  concurrencyMode: string;
  createTime: string;
  locationId: string;
  name: string;
  type: string;
  uid: string;
  updateTime: string;
  versionRetentionPeriod: string;
  // formated name
  formatedName: string;
}

export interface FirestoreStateI {
  collectionIds: string[];
  documents: FirestoreDocumentI[];
  docs: FirestoreDocsI[];
  doc: FirestoreDocI;
  subcollections: string[];
  documentsInSubcollection: FirestoreDocumentI[];
  databases: FirestoreDatabaseI[];
}

export const state: FirestoreStateI = {
  collectionIds: [],
  documents: [],
  docs: [],
  doc: {
    name: '',
    fields: {},
    createTime: '',
    updateTime: '',
  },
  subcollections: [],
  documentsInSubcollection: [],
  databases: [],
};
